import * as messageAction from "../../store/message/action";

import { Button, Modal } from "reactstrap";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import PropTypes from "prop-types";

const Message = () => {
  const dispatch = useDispatch();
  const messageReducer = useSelector(state => state.Message);
  return (
    <>
      {
        <Modal
          isOpen={messageReducer.show}
          scrollable={true}
          backdrop={"static"}
          centered={true}
        >
          <div className="modal-header">
            <h5 className="modal-title">{messageReducer.title}</h5>
          </div>
          <div className="modal-body">
            <h5 className="mt-3">{messageReducer.message}</h5>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success"
              onClick={() => dispatch(messageAction.hideMessage())}
            >
              OK
            </button>
          </div>
        </Modal>
      }
    </>
  );
};

export default Message;
